/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiConversation,
  AiConversationRequestInput,
  ListAiConversationsParams,
  PaginatedAiConversations,
  SchemaValidationErrorResponse,
  SearchAiConversationsParams
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create AI Conversation
 */
export const createAiConversation = (
    aiConversationRequestInput: MaybeRefOrGetter<AiConversationRequestInput>,
 signal?: AbortSignal
) => {
      aiConversationRequestInput = toValue(aiConversationRequestInput);

      return axiosClient<AiConversation>(
      {url: `/ai/conversations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiConversationRequestInput, signal
    },
      );
    }




export const getCreateAiConversationMutationKey = () => ['createAiConversation'] as const;

export const getCreateAiConversationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiConversation>>, TError,CreateAiConversationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiConversation>>, TError,CreateAiConversationMutationVariables, TContext> => {

const mutationKey = getCreateAiConversationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiConversation>>, CreateAiConversationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAiConversation(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiConversationMutationResult = NonNullable<Awaited<ReturnType<typeof createAiConversation>>>
    export type CreateAiConversationMutationBody = AiConversationRequestInput
    export type CreateAiConversationMutationError = ErrorType<void>
    export type CreateAiConversationMutationVariables = {data: AiConversationRequestInput}

    /**
 * @summary Create AI Conversation
 */
export const useCreateAiConversation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiConversation>>, TError,CreateAiConversationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiConversation>>,
        TError,
        CreateAiConversationMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAiConversationMutationOptions(options), queryClient);
    }
    /**
 * @summary List of AI Conversations
 */
export const listAiConversations = (
    params?: MaybeRefOrGetter<ListAiConversationsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiConversations>(
      {url: `/ai/conversations`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAiConversationsQueryKey = (params?: MaybeRefOrGetter<ListAiConversationsParams>,) => {
    return [
    'ai','conversations', ...(params ? [params] : [])
    ] as const;
    }


export const getListAiConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listAiConversations>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListAiConversationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiConversations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiConversationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiConversations>>> = ({ signal }) => listAiConversations(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiConversations>>, TError, TData>
}

export type ListAiConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiConversations>>>
export type ListAiConversationsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of AI Conversations
 */

export function useListAiConversations<TData = Awaited<ReturnType<typeof listAiConversations>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListAiConversationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiConversations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Search of AI Conversations
 */
export const searchAiConversations = (
    params?: MaybeRefOrGetter<SearchAiConversationsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiConversations>(
      {url: `/ai/conversations/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchAiConversationsQueryKey = (params?: MaybeRefOrGetter<SearchAiConversationsParams>,) => {
    return [
    'ai','conversations','search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchAiConversationsQueryOptions = <TData = Awaited<ReturnType<typeof searchAiConversations>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<SearchAiConversationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAiConversations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchAiConversationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAiConversations>>> = ({ signal }) => searchAiConversations(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchAiConversations>>, TError, TData>
}

export type SearchAiConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof searchAiConversations>>>
export type SearchAiConversationsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Search of AI Conversations
 */

export function useSearchAiConversations<TData = Awaited<ReturnType<typeof searchAiConversations>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<SearchAiConversationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAiConversations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchAiConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete AI Conversation
 */
export const deleteAiConversation = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/conversations/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAiConversationMutationKey = () => ['deleteAiConversation'] as const;

export const getDeleteAiConversationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiConversation>>, TError,DeleteAiConversationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiConversation>>, TError,DeleteAiConversationMutationVariables, TContext> => {

const mutationKey = getDeleteAiConversationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiConversation>>, DeleteAiConversationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAiConversation(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiConversationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiConversation>>>

    export type DeleteAiConversationMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteAiConversationMutationVariables = {id: string}

    /**
 * @summary Delete AI Conversation
 */
export const useDeleteAiConversation = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiConversation>>, TError,DeleteAiConversationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiConversation>>,
        TError,
        DeleteAiConversationMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAiConversationMutationOptions(options), queryClient);
    }
    /**
 * @summary AI Conversation Details
 */
export const getAiConversation = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AiConversation>(
      {url: `/ai/conversations/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetAiConversationQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'ai','conversations',id
    ] as const;
    }


export const getGetAiConversationQueryOptions = <TData = Awaited<ReturnType<typeof getAiConversation>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiConversationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiConversation>>> = ({ signal }) => getAiConversation(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiConversation>>, TError, TData>
}

export type GetAiConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getAiConversation>>>
export type GetAiConversationQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary AI Conversation Details
 */

export function useGetAiConversation<TData = Awaited<ReturnType<typeof getAiConversation>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversation>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiConversationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update AI Conversation
 */
export const updateAiConversation = (
    id: MaybeRefOrGetter<string>,
    aiConversationRequestInput: MaybeRefOrGetter<AiConversationRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
aiConversationRequestInput = toValue(aiConversationRequestInput);

      return axiosClient<AiConversation>(
      {url: `/ai/conversations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: aiConversationRequestInput, signal
    },
      );
    }




export const getUpdateAiConversationMutationKey = () => ['updateAiConversation'] as const;

export const getUpdateAiConversationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiConversation>>, TError,UpdateAiConversationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAiConversation>>, TError,UpdateAiConversationMutationVariables, TContext> => {

const mutationKey = getUpdateAiConversationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiConversation>>, UpdateAiConversationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateAiConversation(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiConversationMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiConversation>>>
    export type UpdateAiConversationMutationBody = AiConversationRequestInput
    export type UpdateAiConversationMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateAiConversationMutationVariables = {id: string;data: AiConversationRequestInput}

    /**
 * @summary Update AI Conversation
 */
export const useUpdateAiConversation = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiConversation>>, TError,UpdateAiConversationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAiConversation>>,
        TError,
        UpdateAiConversationMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAiConversationMutationOptions(options), queryClient);
    }
